import React from "react";
import { 
    getNativeAppQueryParamsValuesByKey, 
    Is_BrotherPlus_Signup
} from "../../constants/AppMethod";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths } from "../../constants/Routes";
import { NATIVE_APP_SELECTION_ATTRIBUTE } from "../../constants/AppConstants";
import Loader from "../../components/shared/loader/Loader";

const ProcessHandler = () => {
    const history = useHistory();
    const IsBrotherPlus_Signup = Is_BrotherPlus_Signup();
    const serviceTypeSelected = parseInt(getNativeAppQueryParamsValuesByKey("selection"));

    const handleNativeAppRedirection = () => {
        history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
    }

    const handleBrotherPlusServiceProcess = () => {
        if(serviceTypeSelected === NATIVE_APP_SELECTION_ATTRIBUTE.BPLUS_SERVICE) {
            history.push(nativeAppRoutePaths.BPLUS.ENROLLMENT_CHECK);
        } else {
            handleNativeAppRedirection()
        }
    }

    const handleEcoproServiceProcess = () => {
        if(serviceTypeSelected === NATIVE_APP_SELECTION_ATTRIBUTE.ECOPRO_SERVICE){
            history.push(nativeAppRoutePaths.ECOPRO.ENROLLMENT_CHECK);
        } else {
            handleNativeAppRedirection()
        }
    }

    if(IsBrotherPlus_Signup){
        handleBrotherPlusServiceProcess();
    } else {
        handleEcoproServiceProcess();
    }
    
    return (
        <Loader />
    )
}

export default ProcessHandler;